import { render, staticRenderFns } from "./InputParcelas.vue?vue&type=template&id=61a64a25"
import script from "./InputParcelas.vue?vue&type=script&lang=js"
export * from "./InputParcelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports